const coupons = [{
	path: '/usage-coupon',
	name: 'usage-coupon',
	component: _ => import('@/pages/coupons/index.vue'),
	meta: {
		title: '优惠券领取'
	},
},
{
	path: '/success-page',
	name: 'success-page',
	component: _ => import('@/pages/coupons/success-page.vue'),
	meta: {
		title: '领取成功'
	},
},
{
	path: '/usage-coupon-goods',
	name: 'usage-coupon-goods',
	component: _ => import('@/pages/coupons/goods.vue'),
	meta: {
		title: '可用商品'
	},
},
{
	path: '/invitation',
	name: 'invitation',
	component: _ => import('@/pages/invitation/index.vue'),
	meta: {
		title: '邀请码'
	},
}
]
export default coupons;
